import React from "react";
import Typewriter from "../components/TypeWriter";
import { NavHashLink } from "react-router-hash-link";
import { scrollWithOffset } from "../utils/helpers";
import { useMediaQuery } from "react-responsive";

function About() {

  const isBigScreen = useMediaQuery({ query: "(min-width: 1023px)" });
  const customOffset = isBigScreen ? 120 : 100;
const textSize =
"lg:text-7xl xl:text-8xl md:text-7xl text-6xl uppercase font-ivy_mode text-text";
  return (
    <section id="about">
    <h1 className="uppercase text-sm tracking-[4px] text-center pb-6">About Ziva Interiors</h1>
    <div className="px-5 grid lg:grid-cols-2 grid-cols pb-10 lg:gap-10">
      <div className="">
        <h1 className={`${textSize}`}>Setting</h1>
        <h1 className={`${textSize}`}>Standards</h1>
        <h1 className={`${textSize}`}>In Interior</h1>
        <h1 className={`${textSize}`}>Design</h1>
      </div>
      <div className="pt-10">
        <h1 className="font-sweet_romance lg:text-6xl text-5xl text-center p-5 text-main">
         <Typewriter />
        </h1>
        <p className="text-2xl">
          At Ziva Interiors, we believe that great design can transform any
          space into a work of art. We are dedicated to bringing your vision
          to life, whether you're looking to update a single room or redesign
          your entire home or business. With our extensive knowledge of color,
          texture, and materials, we'll help you create a space that's both
          beautiful and functional. Let us help you make a statement with our
          interior design. <NavHashLink to={"/#contact"} scroll={(el) => scrollWithOffset(el, customOffset)} className="hover:cursor-pointer text-main">Contact us</NavHashLink> today to get started.
        </p>

      </div>
    </div>
  </section>
  );
}

export default About;
